import produce from 'immer';

// UTILS
import { toSelect } from 'utils/genericFunctions';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, Sexos } from './types';

export const INITIAL_STATE: Sexos = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Sexos {
	return produce(state, draft => {
		switch (action.type) {
			case Types.SEXOS_REQUEST: {
				break;
			}
			case Types.SEXOS_SUCCESS: {
				draft.status = action.payload.status;
				const select = toSelect(
					action.payload.data.dominio,
					'descricao',
					'codigo',
				);
				draft.data = select;
				break;
			}
			case Types.SEXOS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.SEXOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
